document.addEventListener('DOMContentLoaded', () => {
    // Initialize only if both price elements are present
    const priceSingleElement = document.getElementById('price-single');
    const priceBuy3Element = document.getElementById('price-buy-3');
    const price2Pack = document.getElementById('price-2-pack');    
    const priceCombo = document.getElementById('price-combo');
    const priceLarge = document.getElementById('price-large');
    const priceSmall = document.getElementById('price-small');
    const memberPrice = document.getElementById('member-price');
    

    if (!priceSingleElement || !priceBuy3Element || !memberPrice || !price2Pack) {
        return; // Exit if required elements are not present
    }

    // Delegate the click event to the .tt-options-swatch container
    document.body.addEventListener('click', (event) => {
        // Ensure the click happened on an <li> within a .tt-options-swatch
        const clickedElement = event.target.closest('.tt-options-swatch li');
        const optionsList = event.target.closest('.tt-options-swatch');

        if (clickedElement && optionsList) {
            // Prevent default link action
            event.preventDefault();

            // Get the data-value of the clicked <li>
            const textSelectedValue = clickedElement.querySelector('a').getAttribute('data-value');
            //const selectedValue = clickedElement.querySelector('a').getAttribute('data-value');
            const selectedValue = textSelectedValue.replace(/\s+/g, ' ');

            // Update the member price based on the selected option
            if (selectedValue === 'Small') {
                memberPrice.textContent = priceSmall.textContent;
            } else if (selectedValue === 'Large') {
                memberPrice.textContent = priceLarge.textContent;
            } else if (selectedValue === 'Combo') {
                memberPrice.textContent = priceCombo.textContent;
            } else if (selectedValue === 'Single' || selectedValue === 'Single Pack' ) {
                memberPrice.textContent = priceSingleElement.textContent;
                console.log('Price updated to Single: ' + priceSingleElement.textContent);
            } else if (selectedValue === '2 Pack') {
                memberPrice.textContent = price2Pack.textContent;
            } else if (selectedValue === 'Buy 3 Get 1 Free') {
                memberPrice.textContent = priceBuy3Element.textContent;
                console.log('Price updated to Buy 3 Get 1 Free: ' + priceBuy3Element.textContent);
            } else {

                // Set a timeout to allow DOM changes to apply
                setTimeout(() => {
                    // Check for the active item that matches the required value
                    const activeItems = document.querySelectorAll('.tt-options-swatch li.active a');

                    // Find the correct active item
                    let matchingActiveItem = null;
                    activeItems.forEach(item => {
                        let textActiveValue = item.getAttribute('data-value');
                        //let activeValue  = "Buy 3  Get 1 Free";
                        activeValue = textActiveValue.replace(/\s+/g, ' ');
                      
                        if (activeValue === 'Single' || activeValue === 'Buy 3 Get 1 Free') {
                            matchingActiveItem = item;
                        }
                    });

                    if (matchingActiveItem) {
                        const activeValue = matchingActiveItem.getAttribute('data-value');
                        console.log('Active value found: ' + activeValue);

                        // Update the member price based on the found active value
                        if (selectedValue === 'Small') {
                            memberPrice.textContent = priceSmall.textContent;
                        } else if (selectedValue === 'Large') {
                            memberPrice.textContent = priceLarge.textContent;
                        } else if (selectedValue === 'Combo') {
                            memberPrice.textContent = priceCombo.textContent;
                        } else if (selectedValue === 'Single' || selectedValue === 'Single Pack' ) {
                            memberPrice.textContent = priceSingleElement.textContent;
                        } else if (selectedValue === '2 Pack') {
                            memberPrice.textContent = price2Pack.textContent
                        } else if (activeValue === 'Buy 3 Get 1 Free') {
                            memberPrice.textContent = priceBuy3Element.textContent;
                        }
                    } else {
                        console.log('No matching active item found.');
                    }
                }, 200); // Ajusta el tiempo según sea necesario

                
            }

            // Update the active class on the selected option
            optionsList.querySelectorAll('li').forEach(opt => opt.classList.remove('active'));
            clickedElement.classList.add('active');
        }
    });
});
